import React from "react";
import PropTypes from "prop-types";

import "./account-benefit.scss";

const AccountBenefit = ({ imgSrc, title, description, children }) => (
  <div className="account-benefit">
    <img
      alt=""
      aria-hidden={true}
      className="account-benefit__icon"
      src={imgSrc}
    />
    <h3 className="account-benefit__title">{title}</h3>
    <p className="account-benefit__description">{description}</p>
    {children}
  </div>
);

AccountBenefit.propTypes = {
  imgSrc: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  children: PropTypes.node
};

export default AccountBenefit;
